import { dateRangePreset } from "./state";

const toDateKey = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString().slice(0, 10);
};

export const getEffectiveRealtimeEndDate = (rawEndDate: string) => {
  if (dateRangePreset.value === "live") {
    return new Date().toISOString();
  }

  const todayKey = new Date().toISOString().slice(0, 10);
  const endKey = toDateKey(rawEndDate);

  if (endKey && endKey >= todayKey) {
    return new Date().toISOString();
  }

  return rawEndDate;
};
